export default {
  title: 'Partners',
  search_placeholder: 'Partner zoeken...',
  buttons: {
    default_price_list: 'Standaard prijslijst',
    create_partner: 'Partner aanmaken',
  },
  columns: {
    name: 'Naam',
    restaurants: 'Restaurants',
    shop_domain: 'Shopdomein',
    status: 'Status',
    earning_enabled: 'Inkomsten ingeschakeld',
  },
  statuses: {
    invited: 'Uitgenodigd',
    active: 'Actief',
    suspended: 'Geschorst',
  },
  actions: {
    edit: 'Bewerken',
    view_billing: 'Facturering bekijken',
    view_as_partner: 'Bekijken als partner',
    suspend: 'Schorsen',
    unsuspend: 'Schorsing opheffen',
  },
  suspension: {
    suspend_title: 'Deze partner schorsen?',
    suspend_description:
      'Alle teamleden van de partner worden gedeactiveerd en hun sessies ingetrokken. Hun restaurants blijven actief.',
    unsuspend_title: 'Schorsing van deze partner opheffen?',
    unsuspend_description: 'Alle teamleden van de partner worden opnieuw geactiveerd en kunnen weer inloggen.',
  },
  toasts: {
    load_error: 'Partners konden niet worden geladen.',
    suspended: 'De partner is geschorst.',
    unsuspended: 'De schorsing van de partner is opgeheven.',
    suspension_error: 'Kan de partnerstatus niet wijzigen.',
    view_as_error: 'Kan het partnerdashboard niet openen.',
  },
};
